var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNursePointerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#436168;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,9C20.7,9,10,19.7,10,33s10.7,24,24,24h24V33C58,19.7,47.3,9,34,9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 120,
    height: 120,
    xlinkHref: "D96F3F9BB5D869BC.png",
    transform: "matrix(1 0 0 1 -27 -30)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,4C18.7,4,8,14.7,8,28s10.7,24,24,24h24V28C56,14.7,45.3,4,32,4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.6,47.6h-6.3c-1.8,0-3.3-1.5-3.3-3.3v-3.2c0-1-0.5-1.9-1.2-2.4c-3.6-2.5-5.7-6.6-5.7-11 c0-7.4,6-13.4,13.4-13.4c7.4,0,13.2,5.8,13.4,13.1l0,0c0.1,4.4-2,8.6-5.6,11.2c-0.8,0.6-1.3,1.5-1.3,2.5v3.2 C38.8,46.1,37.4,47.6,35.6,47.6z M32.4,17.1c-5.9,0-10.6,4.8-10.6,10.6c0,3.5,1.7,6.7,4.5,8.7c1.5,1.1,2.4,2.8,2.4,4.7v3.2 c0,0.3,0.2,0.5,0.5,0.5h6.3c0.3,0,0.5-0.2,0.5-0.5v-3.2c0-1.9,0.9-3.7,2.5-4.8c2.9-2,4.5-5.3,4.5-8.8l0,0 C42.9,21.7,38.2,17.1,32.4,17.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,28.2c0-0.9-0.2-1.8-0.6-2.6c-0.6-1.3-1.7-2.4-3-3l1.2-2.5c1.9,0.9,3.4,2.5,4.2,4.3 c0.5,1.2,0.8,2.4,0.9,3.7L37.1,28.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 8.3,
    className: "st0",
    width: 2.8,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.4,
    y: 13.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.1797 18.5413)",
    className: "st0",
    width: 2.8,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26.9,
    className: "st0",
    width: 3.5,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.4,
    y: 39.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -23.0039 26.2342)",
    className: "st0",
    width: 3.5,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 38.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.3118 44.0552)",
    className: "st0",
    width: 2.8,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 26.4,
    className: "st0",
    width: 3.5,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 13.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 2.5125 36.366)",
    className: "st0",
    width: 3.5,
    height: 2.8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursePointerRight);
export default __webpack_public_path__ + "static/media/Nurse_pointer_right.f30040c2bf0a1d6641a7342738af6601.svg";
export { ForwardRef as ReactComponent };